import * as React from 'react';
import { IHeader } from "../ItemCreation";
import { IBaseEntity } from '../../../entities/common';

export type SecondaryMessage = ((entity: IBaseEntity) => string | JSX.Element) | string | JSX.Element;

export type Props = {
    entity: IBaseEntity;
    readOnly: boolean;
    header?: Partial<IHeader>;
    entityTypeLabel: string;
    secondaryMessage?: SecondaryMessage
}

const HeaderSecondaryText = React.memo(({ entity, secondaryMessage, readOnly, header, entityTypeLabel }: Props) => {
    const message = typeof secondaryMessage === 'function' ? secondaryMessage(entity) : secondaryMessage;
    return <>
        <div>
            {header?.secondaryText
                ?? (readOnly
                    ? `Check fields below to view the ${entityTypeLabel}`
                    : `Fill in the fields below to edit the ${entityTypeLabel}`)}
        </div>
        {message && <div className="message-bar">{message}</div>}
    </>;
});

export default HeaderSecondaryText;